const defaultSearchConfiguration = {
    _searchable: true,
    oldCompanyName: {
        _searchable: true,
        _score: 500,
    },
    newCompanyName: {
        _searchable: true,
        _score: 500,
    },
};

export default defaultSearchConfiguration;
